<div class="container">
  <article class="news-article">
    <a class="news-article-back" routerLink="/news">&#8592; Vissza a hírekhez</a>

    <!-- A sorrend fontos: a resource value()-ja HIBÁT DOB, ha a resource error
         állapotban van, ezért a hibaágakat előbb kell ellenőrizni. -->
    @if (article.isLoading()) {
      <p class="news-status" role="status">A hír betöltése…</p>
    } @else if (notFound()) {
      <h1>A keresett hír nem található</h1>
      <p class="news-status">Lehet, hogy a hír már nem elérhető, vagy hibás a hivatkozás.</p>
    } @else if (article.error()) {
      <h1>Hiba történt</h1>
      <p class="news-status">A hír betöltése nem sikerült. Kérjük, próbálja meg később.</p>
      <button class="news-retry" type="button" (click)="article.reload()">Újratöltés</button>
    } @else if (article.value(); as loaded) {
      <header class="news-article-header">
        <h1>{{ loaded.meta.title }}</h1>
        <time class="news-article-date" [attr.datetime]="loaded.meta.date">
          {{ loaded.meta.date | date: 'longDate' }}
        </time>
        <p class="news-article-lead">{{ loaded.meta.summary }}</p>
      </header>

      <!-- A törzs a /assets/news/<slug>.html fájlból jön. Stílusát a globális
           src/styles/_news-article.scss adja, mert futásidőben kerül be a DOM-ba. -->
      <div class="news-article-body" [innerHTML]="loaded.body"></div>
    }
  </article>
</div>
